// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__35Aw6","vLegacy":"SelectSecondary_vLegacy__pnfH-","error":"SelectSecondary_error__139Ey","disabled":"SelectSecondary_disabled__1BKzR"};